var $ = require('jquery');

$('.page-section--table').each(function() {
    let _this = $(this);
    _this.addClass('table--col-' + _this.find('thead > tr').children().length );
})